import SysLabels from "config/lang/SysLabels";

const Labels = {
  ...SysLabels,
  listResguardos: "Resguardos",
  createDocument: "Crear resguardo",
  editDocument: "Editar resguardo",
  documentData: "Datos del resguardo",
  emptyResguardos: "Sin resguardos registrados",
  dateFrom: "Fecha desde",
  dateTo: "Fecha hasta",
  lines: "Lineas",
  article: "Artículo",
  quantity: "Cantidad",
  unitPrice: "Precio unitario",
  quantityAbbreviation: "Cant",
  unitPriceAbbreviation: "P/U",
  subtotal: "Subtotal",
  total: "Total",
  emptyLines: "Sin lineas registradas",
  partner: "Socio",
  discount: "Descuento",
  tax: "IVA",
  taxAbbreviation: "IVA",
  unit: "Unidad",
  indicator: "Indicador de facturación",
  rounding: "Redondeo",
  totals: "Totales",
  holder: "Titular del resguardo",
  lot: "Lote",
};

export default Labels;
